var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "email-preview-container" },
    [
      _setup.loading
        ? _c(_setup.SpinnerLayer)
        : _c(
            "div",
            { staticClass: "email-preview" },
            [
              _c(_setup.ClosePreviewComponent, {
                on: { "close-viewer-event": _setup.closeViewerEvent },
              }),
              _c("div", {
                staticClass: "email",
                domProps: { innerHTML: _vm._s(_setup.htmlContent) },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }